import React, {Component} from 'react';
import {connect} from 'react-redux';
// containers
import Mobile from './mobile/containers/main';
import Desktop from './desktop/containers/main';
// actions
import {setIsDesktopMode} from '../../actions/systemActions';
// constants
import {CHIPS} from '../../constants/chips'
import {ASSETS_URL} from '../../constants/endpoints';

const mapStateToProps = (state, ownProps) => {
    return {isDesktopMode: state.vpp.isDesktopMode};
};

//TODO: Confirm the minimum ratio for the display screen
const MINIMUM_SCREEN_RATIO = 0.7;

class Simplified extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isDesktopMode: storeData.vpp.isDesktopMode,
            resizeWidthInPx: 1000
        };
        this._setDimensions();
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();

        this.setState({
            ...this.state,
            isDesktopMode: storeData.vpp.isDesktopMode
        });
    }

    componentDidMount() {
        window.addEventListener('resize', this._setDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._setDimensions.bind(this));
    }

    _setDimensions() {
        let isDesktopMode = window.innerWidth > this.state.resizeWidthInPx && window.innerWidth / window.innerHeight > MINIMUM_SCREEN_RATIO;

        if (isDesktopMode !== this.state.isDesktopMode) {
            this.props.store.dispatch(setIsDesktopMode(isDesktopMode));
        }
    }

    render() {
        // preload chip assets and loading icon
        let chipsAssets = CHIPS.map((chip, index) => (
            <img src={`${ASSETS_URL + chip.assetChip}`} alt={'chips'} key={index}/>));
        let loadingIcon = (<img src={`${ASSETS_URL}miscellaneous/loading.gif`} alt={'loading'}/>);
        let simplifiedUI = this.state.isDesktopMode
            ? (<Desktop store={this.props.store}/>)
            : (<Mobile store={this.props.store}/>);
        return (
            <div>
                <div style={{
                    display: 'none'
                }}>
                    {chipsAssets}
                    {loadingIcon}
                </div>
                {simplifiedUI}
            </div>
        );
    }
}

export default connect(mapStateToProps)(Simplified);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/simplified.js